<template>
  <div>
    <div class="sectionBox">
      <!-- 标题 -->
      <ots-main-title></ots-main-title>
      <el-alert title="" type="warning" v-if="!apptitle">
        <span class="importantNote" v-for="item in appointment" :key="item.index">
           <span>{{item.examDate }}</span>预约考试人数<span style="margin-right: 20px;">{{ item.stuCount }}人</span>
        </span>
      </el-alert>
      <ots-refer
        class="mb20"
        :selectList="selectList"
        :request-form="sectionSelectParams"
        @search="getSectionList"
      />
      <!-- 列表 -->
      <div class="mainCon">
        <h4 class="mb20">批次名称：{{ planInfo.name }}</h4>
        <ots-table-group
          :tableHeader="tableHeader"
          :tableData="tableData"
          :batchOperBtn="batchOperBtn"
          :pagination="pagination"
          @handleSelectionChange="bachOper"
          @changeNum="changeSize"
          @changePage="changePage"
        ></ots-table-group>
      </div>
    </div>

    <!-- 导入免考名单 -->
    <ots-custom-dialog :dialog.sync="showDialog" :title="arrangementName ? arrangementName: '查看详情'" width="580px">
      <template v-slot:content>
        <ul>
          <li v-for="(item, index) in placeClassList" :key="index" style="margin-bottom: 16px;">
            <p style="font-size: 18px; font-weight: 700; margin-bottom: 8px;">{{item.placeName}}</p>
            <div style="display: flex; justify-content: left; flex-wrap: wrap;">
              <span v-for="(e, i) in item.className.split(',')" :key="i" style="display:inline-block; width: 168px; margin-bottom: 8px;">{{e}}</span>
            </div>
          </li>
        </ul>
      </template>
      <template v-slot:footer>
        <el-button round @click="showDialog = false" type="primary" plain>关闭窗口</el-button>
      </template>
    </ots-custom-dialog>
  </div>
</template>
<script>
import {
  getPlanSignDateCountShow,
  getCurrentPlanFn,
} from "@/http/modules/examSet/examBatch";
import {
  getSectionList,
  getPlanSite,
  deleteSessionFn,
  PlanPlaceCourse
} from "@/http/modules/examSet/section";
export default {
  name: "sectionLook",
  data() {
    return {
      apptitle:false,
      appointment:[],
      titlecode:this.$route.query.code,
      selectSections: [],
      tableHeader: [
        {
          title: "场次名称",
          prop: "name",
          width: "120",
        },
        {
          title: "考试起止时间",
          formatter:(scope)=>{
            return scope.row.beginTime+'-'+scope.row.endTime;
          }
        },
        {
          title: "考试课程",
          prop: "courseNames",
        },
        {
          title: "考试活动",
          prop: "arrangementName",
        },
        {
          title: "试卷名称",
          prop: "paperName",
        },
        {
          title: "考点",
          prop: "placeNames",
        },
        {
          title: "教室",
          type: "isButton",
          prop: "classNames",
          click: this.show
        },
      ],
      tableData: [],
      batchOperBtn: [
        {
          title: "返回",
          click: () => {
            this.$router.go(-1);
          },
        },
      ],
      pagination: {
        total: 0,
      },
      sectionSelectParams: {
        //planId: "",
        placeId: "",
        courseId:""
      },
      sectionListParams: {
        page: 1,
        size: 10,
      },
      selectList: [
        {
          title: "考点",
          type: "select",
          requestKey: "placeId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "考试课程",
          type: "select",
          requestKey: "courseId",
          label: "courseName",
          value: "courseId",
          data: [],
        },
      ],
      planInfo: {},
      showDialog: false,
      placeClassList: [],
      arrangementName: "",
    };
  },
  watch: {
    "sectionSelectParams.placeId"(val) {
      this.PlaceCourse()
      this.getSectionList();
    },
    "sectionSelectParams.courseId"(val) {
      this.getSectionList();
    },
    $route: "getPath",
  },
  created() {
    this.initData();
    this.getSiteData();
    this.PlaceCourse()
  },
  methods: {
    show(row) {
      // this.arrangementName = row.arrangementName;
      this.arrangementName = this.planInfo.name + " -- " + row.name;
      this.placeClassList = row.placeClassList
      this.showDialog = true;
    },

    getPlanSignDateCount(){
      getPlanSignDateCountShow({planId: this.$route.query.id}).then(res=>{
        this.appointment= res.data
        if(this.appointment !== null && this.appointment.length){
          this.apptitle = false
        }else{
          this.apptitle = true
        }
      })
    },
    bachOper(val) {
      this.selectSections = val;
    },
    async initData() {
      // 获取所有考试批次
      //   const planData = await this.mixin_getSelectPlan();
      //   this.selectList[0].data = planData;

      // 当前考试批次
      const plan = await getCurrentPlanFn({
        planId: this.$route.query.id,
      });
      this.planInfo = plan.data;
      this.sectionSelectParams.planId = plan.data.id;
      this.getSectionList();
      this.getPlanSignDateCount()
    },
    async getSiteData() {
      //this.sectionSelectParams.placeId = "";
      const { data } = await getPlanSite({
        planId: this.$route.query.id,
      });
      let siteTemp = Array.isArray(data) ? data : [];
      if (siteTemp.length) {
        this.selectList[0].data = [{ id: "", name: "全部" }].concat(siteTemp);
      } else {
        this.selectList[0].data = [];
      }
    },
    async PlaceCourse(){
      this.sectionSelectParams.courseId = "";
      const {data} =await PlanPlaceCourse({
        planId: this.$route.query.id,
        placeId:this.sectionSelectParams.placeId
      })
      let placeList = [{ courseId: "", courseName: "全部" }, ...data];
      this.$set(this.selectList[1], "data", placeList);
    },
   
    addPlanDialog() {
      this.$router.push({
        name: "addSection",
        query: {
          planId: this.$route.query.id,
        },
      });
    },
    editSection(row) {
      this.$router.push({
        name: "editSection",
        query: {
          id: row.id,
          planId: this.$route.query.id,
        },
      });
    },
    checkSection(row) {
      this.$router.push({
        name: "checkSection",
        query: {
          id: row.id,
          planId: this.$route.query.id,
        },
      });
    },
    deleteSection(row) {
      this.$confirm("确定删除该考试场次?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { code } = await deleteSessionFn({ sessionId: row.id });
          if (code == 1) {
            this.$message.success("删除成功");
            this.getSectionList();
          }
        })
        .catch(() => {});
    },
    changeSize(num) {
      this.sectionListParams.size = num;
      this.getSectionList();
    },
    changePage(p) {
      this.sectionListParams.page = p;
      this.getSectionList();
    },


    /**
     * @param { 获取表格数据 tableData }
     */
    async getSectionList() {
      let params = Object.assign(
        this.sectionListParams,
        this.sectionSelectParams
      );
      const { data } = await getSectionList(params);
      this.tableData = data.records;
      this.pagination.total = data.total;
    },



    getPath() {
      if (this.$route.name == "section") {
        this.getSectionList();
      }
    },
    beforeBatch() {
      if (this.selectSections.length > 0) {
        return true;
      } else {
        this.$message.warning("请先选择场次");
        return false;
      }
    },
    deleteSchool(row) {
      if (row || this.beforeBatch()) {
      } else {
        return false;
      }
      let param = {
        ids: row ? row.id : this.selectIds.join(),
      };
      this.$confirm("确定删除该学校?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { code } = await deleteSchoolFn(param);
          if (code == 1) {
            this.$message.success("删除成功");
            this.getAllSchoolFn();
          }
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
.mainCon {
  padding: 20px;
  border-radius: 8px;
  background-color: #fff;
  flex: 1;
}
.el-alert {
    margin-bottom: 24px;
    background: #fff5e0;
    border: 1px solid #ff9500;
    
    box-sizing: border-box;
    .importantNote {
      font-size: 14px;
      color: #ff9500;
      margin-left: -10px;
      margin-top: -7px;
     
    }
    /deep/ .el-alert__closebtn {
      top: 17px;
      color: #ff9500;
    }
  }
</style>
